import React from 'react'
import styled from 'styled-components'
import InfoPopover, { PopItem, PopLead, PopList } from 'features/actions/workspace/InfoPopover'

const ChartKeyExplainer = ({ title, lead, buckets = [], drillNote }) => (
  <InfoPopover label={`What the colours in ${title.toLowerCase()} mean`} title={`${title}: what the colours mean`}>
    {lead ? <PopLead>{lead}</PopLead> : null}
    <PopList>
      {buckets.map(b => (
        <PopItem key={b.key}>
          <span>
            <Swatch style={{ background: b.tint }} aria-hidden='true' />
            <strong>{b.label}</strong>: {b.help}
          </span>
        </PopItem>
      ))}
    </PopList>
    {drillNote ? <PopLead>{drillNote}</PopLead> : null}
  </InfoPopover>
)

export default ChartKeyExplainer

const Swatch = styled.span`
  display: inline-block; width: 10px; height: 10px; border-radius: 3px;
  margin-right: 7px; vertical-align: baseline; flex-shrink: 0;
`
